import EmptySpace from './EmptySpace'

export default EmptySpace
